import { Schema as S } from "effect";
export const Schema = S.Union(S.Literal("live"), S.Literal("test")).pipe(S.brand("@open-revenue/schema/subscriptions/SubscriptionEnvironment"));
export const Type = Schema.Type;
export const Live = "live";
export const Test = "test";
export const make = (provider)=>S.decodeUnknown(Schema)(provider);
export const makeUnsafe = (provider)=>provider;
